<script setup lang="ts">
definePageMeta({ layout: false })

const { loggedIn } = useUserSession()
if (loggedIn.value) await navigateTo('/')

const route = useRoute()
const errorMessage = computed(() => {
  if (route.query.error === 'unauthorized_domain') {
    return 'Povoleny jsou pouze účty @scg.cz.'
  }
  return null
})

const isDev = import.meta.dev

async function devLogin(role: 'obchodni-tym' | 'vedeni-obchodu' = 'obchodni-tym') {
  await $fetch('/api/auth/dev-login', { method: 'POST', body: { role } })
  await navigateTo('/')
}
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center font-sans px-4">
    <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-10 w-full max-w-sm text-center">
      <div class="w-12 h-12 rounded-xl bg-primary mx-auto mb-5 flex items-center justify-center">
        <svg class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>

      <h1 class="text-2xl font-semibold text-gray-800 mb-1">SCG ColdMailer</h1>
      <p class="text-sm text-gray-400 mb-8">AI pipeline pro oslovování partnerů</p>

      <div
        v-if="errorMessage"
        class="mb-5 px-4 py-3 rounded-lg bg-red-50 border border-red-100 text-sm text-danger"
      >
        {{ errorMessage }}
      </div>

      <a
        href="/api/auth/login"
        class="inline-flex items-center justify-center gap-3 bg-primary text-white px-6 py-3 rounded-lg font-medium hover:opacity-90 active:opacity-80 transition-opacity w-full"
      >
        <svg class="w-5 h-5" viewBox="0 0 24 24">
          <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
          <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
          <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
          <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
        </svg>
        Pokračovat přes Google
      </a>

      <p class="mt-5 text-xs text-gray-400">Pouze účty @scg.cz</p>

      <div v-if="isDev" class="mt-6 pt-5 border-t border-gray-100 flex gap-4 justify-center">
        <button
          class="text-[11px] text-gray-300 hover:text-gray-500 transition-colors cursor-pointer"
          @click="devLogin('obchodni-tym')"
        >
          ⚙ Obchodní tým
        </button>
        <button
          class="text-[11px] text-gray-300 hover:text-gray-500 transition-colors cursor-pointer"
          @click="devLogin('vedeni-obchodu')"
        >
          ⚙ Vedení obchodu
        </button>
      </div>
    </div>
  </div>
</template>
